import deepmerge from 'deepmerge'
import { getDefaultAisConfig, IAisConfig } from './ais/IAisConfig'
import { IIrisConfigContainerConstParam, IrisConfigContainer } from './IrisConfigContainer'
import { IIrisModContainerConstParam, IrisModContainer } from './IrisModContainer'

export class IrisrawModAis extends IrisModContainer<IrisConfigContainer<IAisConfig>> {
  constructor({ ...args }: IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
    super(args, IrisrawModAis.createIrisAisConfig)
  }

  static createIrisrawModAis(datas: IIrisModContainerConstParam) {
    return new IrisrawModAis(datas)
  }

  static createIrisAisConfig(data: IIrisConfigContainerConstParam) {
    return new IrisConfigContainer<IAisConfig>(deepmerge( {mod_settings:getDefaultAisConfig()},data))
  }
}
